import { IClauseComment } from "@/api/comments";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { formatDate } from "@/utils";

interface IProps {
    comment: IClauseComment;
}

export const Comment = ({ comment }: IProps) => {
    const formattedDate = formatDate(comment.created_at);
    return (
        <>
            <Box
                sx={{
                    display: "inline-block",
                }}
            >
                <Stack flexDirection={"row"} gap={1} alignItems={"flex-start"}>
                    <Avatar
                        sx={{
                            width: 24,
                            height: 24,
                            backgroundColor: "#BDBDBD",
                        }}
                    />
                    <Stack gap={1} justifyContent={"center"}>
                        <Stack
                            flexDirection={"row"}
                            gap={1}
                            alignItems={"center"}
                        >
                            <Typography fontSize="13px" fontWeight={500}>
                                {comment.user.first_name +
                                    " " +
                                    comment.user.last_name[0] +
                                    "."}
                            </Typography>
                            <Typography
                                fontSize="12px"
                                color="#00000099"
                                fontWeight={500}
                            >
                                {formattedDate}
                            </Typography>
                        </Stack>
                        <Typography
                            fontSize={"12px"}
                            sx={{
                                wordWrap: "break-all",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                            }}
                        >
                            {comment.comment}
                        </Typography>
                    </Stack>
                </Stack>
            </Box>
        </>
    );
};
